import { IOnboardingStepViewProps } from "../Onboarding";
import { HookFormSelect, SubmitButton, TextInput } from "../../../hook-form";
import { SectionHeader } from "../../../components";
import { IOnboardingStep1Request } from "../../../interfaces-and-types";
import { IOnboardingStep1ViewProps } from "./OnboardingStep1";
import { countries } from "../../../constants";

export const View = ({
  isLoadingBusinessTypes,
  businessTypes,
  registered_countryFormValue,

  isActive,
  errors: errors,
  handleSubmit: handleSubmit,
  register: register,
}: IOnboardingStep1ViewProps) => {
  return (
    <form onSubmit={handleSubmit}>
      <div className="onboarding-section">
        <SectionHeader
          title="Let’s start with some basics."
          subtitle="We need you to complete your Business profile before you start receiving payments."
        />

        <h5 className="form-section--title font-ctm--bold">Business type</h5>

        <HookFormSelect
          name="registered_country"
          label="Country Of Registration"
          infoIconText="Country where the business is registered. The country of operation may be different from country of registration."
          selectItems={[]}
          selectGroupedItems={countries}
          register={register}
          errors={errors}
          disabled={!isActive}
        />

        <HookFormSelect
          name="registered_business_type_id"
          label="Business Type"
          infoIconText="The ownership structure of the business."
          showSkeleton={isLoadingBusinessTypes}
          selectItems={
            businessTypes.map((businessType) => ({
              text: businessType.business_type_name,
              value: businessType.id,
            })) || []
          }
          register={register}
          errors={errors}
          disabled={!isActive}
        />

        <TextInput
          name="registration_number"
          label={`Business Registration Number ${
            registered_countryFormValue === "NG" ? "" : " (Optional)"
          }`}
          infoIconText="This is the RC or RCN in the cerificate of incorporation. It usually consists of letters and numbers"
          type="text"
          register={register}
          errors={errors}
          disabled={!isActive}
        />

        <div className="flex-container buttons-container">
          {!isActive ? null : (
            <SubmitButton className=" onboarding-submit--button">
              Continue
            </SubmitButton>
          )}
        </div>
      </div>
    </form>
  );
};
